export default {
     imageUrl: "https://royalespaces.com/backend/",
     baseUrl: "https://api.royalespaces.com",
     // imageUrl: "http://localhost:3001/backend",
     // baseUrl: "http://localhost:3001"
};
